export const AutoSuggestDefaultEmits = [
	'input',
	'load',
	'auto-suggest-selected',
	'auto-suggest-cleared',
	'add-new-item',
];
